import React, { useEffect, useState } from 'react'
import { Form, Accordion, Row, Col, InputGroup, Button } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { TEMPLATE_MESSAGES as M, FONT_FAMILY_PLACEHOLDER } from '../templateMessages'

export interface EmailConfig {
    header: {
        logoUrl: string
        align: 'left' | 'center' | 'right'
        backgroundColor: string
        url: string
    }
    footer: {
        text: string
        unsubscribeText: string
        socials: { network: string; url: string }[]
    }
    styles: {
        primaryColor: string
        fontFamily: string
    }
}

interface EmailDesignSettingsProps {
    config: EmailConfig
    onChange: (config: EmailConfig) => void
}

export const DEFAULT_EMAIL_CONFIG: EmailConfig = {
    header: {
        logoUrl: '',
        align: 'center',
        backgroundColor: '#ffffff',
        url: '',
    },
    footer: {
        text: '© 2024 My Company',
        unsubscribeText: 'Unsubscribe',
        socials: [],
    },
    styles: {
        primaryColor: '#007bff',
        fontFamily: 'Arial, sans-serif',
    },
}

export const EmailDesignSettings: React.FC<EmailDesignSettingsProps> = ({ config, onChange }) => {
    const handleChange = (section: keyof EmailConfig, key: string, value: any) => {
        onChange({
            ...config,
            [section]: {
                ...config[section],
                [key]: value,
            },
        })
    }

    return (
        <div className='email-design-settings'>
            <Accordion defaultActiveKey='0'>
                <Accordion.Item eventKey='0'>
                    <Accordion.Header><FormattedMessage {...M.designSection} /></Accordion.Header>
                    <Accordion.Body>
                        <Row className='mb-3'>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label><FormattedMessage {...M.designPrimaryColor} /></Form.Label>
                                    <Form.Control
                                        type='color'
                                        value={config.styles.primaryColor}
                                        onChange={(e) => handleChange('styles', 'primaryColor', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label><FormattedMessage {...M.designFontFamily} /></Form.Label>
                                    <Form.Control
                                        type='text'
                                        placeholder={FONT_FAMILY_PLACEHOLDER}
                                        value={config.styles.fontFamily}
                                        onChange={(e) => handleChange('styles', 'fontFamily', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}
